export const CHANGE_SHOW_MY_BOOKS = 'CHANGE_SHOW_MY_BOOKS';
export const CHANGE_ACTIVE_FILE_DIALOG_TAB = 'CHANGE_ACTIVE_FILE_DIALOG_TAB';
export const CHANGE_IMAGE_BANK_TAB_ID_CHAIN = 'CHANGE_IMAGE_BANK_TAB_ID_CHAIN';
